import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Search as Search$1 } from '../../../icons/index.js';
import styles from './index.module.scss.js';

const Search = forwardRef(
  ({ className, style, value, onChange, placeholder }, forwardedRef) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(Search$1, { className: styles.icon }), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: styles.input,
      ref: forwardedRef,
      value,
      onChange: (event) => onChange(event.target.value),
      placeholder
    }
  ))
);
Search.displayName = "Search";

export { Search };
//# sourceMappingURL=index.js.map
